const IST_OFFSET_MS = (5 * 60 + 30) * 60 * 1000;

export function istLocalToUtcIso(value) {
  if (!value) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(value);
  if (!m) return '';
  const [, y, mo, d, h, mi, se] = m;
  const istWallMs = Date.UTC(
    Number(y),
    Number(mo) - 1,
    Number(d),
    Number(h),
    Number(mi),
    Number(se ?? 0),
  );
  const utcMs = istWallMs - IST_OFFSET_MS;
  return new Date(utcMs).toISOString();
}
